import { AppFieldKey } from './fieldConfig';

export interface FlowStep {
  path: string;
  fieldKey: AppFieldKey;
  exitPath?: string;
  /** When true, a save hook is called automatically if this step is skipped. */
  saveOnSkip?: boolean;
  /** Which save hook to call when saveOnSkip fires. Defaults to 'userProfile'. */
  saveType?: 'userProfile' | 'desiredPartner';
}

export const ONBOARDING_FLOW: FlowStep[] = [
  { path: '/personal-details',         fieldKey: AppFieldKey.PersonalDetails },
  { path: '/IT-specialty',             fieldKey: AppFieldKey.ITSpecialtyScreen },
  { path: '/IT-skills',                fieldKey: AppFieldKey.ITSkills },
  { path: '/IT-ExploreTechnologies',                fieldKey: AppFieldKey.ExploreTechnologies },
  { path: '/IT-workType',              fieldKey: AppFieldKey.WorkType },
  { path: '/IT-AvailabilityType',      fieldKey: AppFieldKey.AvailabilityType },
  { path: '/IT-TotalExperience',       fieldKey: AppFieldKey.ExperienceRange },
  { path: '/IT-workOrganizationCount', fieldKey: AppFieldKey.CompanyCountSelection },
  { path: '/tellup-about',             fieldKey: AppFieldKey.TellUsAboutYou, saveOnSkip: true },
  { path: '/my-profile',               fieldKey: AppFieldKey.UserProfile },
];


export const MATCHING_FLOW: FlowStep[] = [
  { path: '/DesiredExperienceRange',     fieldKey: AppFieldKey.PreferredExperienceRange },
  { path: '/ITPreferredITSpecialities',  fieldKey: AppFieldKey.PreferredITSpecialties },
  { path: '/ITPreferredSkills',          fieldKey: AppFieldKey.PreferredITSkills },
  { path: '/ITpreferredWorkType',        fieldKey: AppFieldKey.PreferredWorkType },
  { path: '/ITpreferredLocation', fieldKey: AppFieldKey.PreferredLocation, exitPath: '/matches', saveOnSkip: true, saveType: 'desiredPartner' },
];

export const ALL_FLOWS: FlowStep[][] = [ONBOARDING_FLOW, MATCHING_FLOW];
